export default "<p>pedidos-globales works!</p>\r\n"